(function (root, factory) {
    var tracker = root.TempStarsSignupLandingView || factory(root);
    root.TempStarsSignupLandingView = tracker;
    if (typeof module === 'object' && module.exports) module.exports = tracker;
})(typeof window !== 'undefined' ? window : {}, function (root) {
    var tracked = false;
    return {
        track: function (analytics, currentUser) {
            if (currentUser || tracked || !analytics || typeof analytics.track !== 'function') return;
            var storage = root.TempStarsBrowserStorage && root.TempStarsBrowserStorage.sessionStorage;
            if (storage && storage.getItem('landingPageTracked')) return;
            // Claim before calling the SDK: React and the delayed legacy bootstrap
            // can otherwise both enter while the first track promise is pending.
            tracked = true;
            if (storage) storage.setItem('landingPageTracked', 'true');
            try { Promise.resolve(analytics.track('sign-up - view start page')).catch(function () {}); }
            catch (_) { /* Tracking availability cannot block the landing page. */ }
        }
    };
});
